import types from './types';

export const mutations = {
  [types.SET_UI_FLAG]($state, uiFlags) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlags };
  },

  [types.CLEAR_ENTRIES]($state) {
    $state.entries.byId = {};
    $state.entries.allIds = [];
  },

  [types.SET_ENTRIES]($state, entries) {
    const byId = {};
    const allIds = [];
    entries.forEach(entry => {
      byId[entry.id] = entry;
      allIds.push(entry.id);
    });
    $state.entries.byId = byId;
    $state.entries.allIds = allIds;
  },

  [types.ADD_ENTRY]($state, entry) {
    if (!entry.id) return;
    $state.entries.byId = { ...$state.entries.byId, [entry.id]: entry };
    if (!$state.entries.allIds.includes(entry.id)) {
      $state.entries.allIds = [...$state.entries.allIds, entry.id];
    }
  },

  [types.UPDATE_ENTRY]($state, entry) {
    if (!$state.entries.allIds.includes(entry.id)) return;
    $state.entries.byId = { ...$state.entries.byId, [entry.id]: entry };
  },

  [types.REMOVE_ENTRY]($state, entryId) {
    const { [entryId]: _removed, ...rest } = $state.entries.byId;
    $state.entries.byId = rest;
    $state.entries.allIds = $state.entries.allIds.filter(id => id !== entryId);
  },
};
